// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1zexH","name":"Header_name__20mIz","birthday":"Header_birthday__1DOsE","skeleton":"Header_skeleton__1YHvH"};